export const STATUS = {
  ABOLISH: 0,
  ACTIVE: 1,
  ENDED: 2,
};

export const STATUS_LOCALIZIED = {
  ABOLISH: "Feshedildi",
  ACTIVE: "Etkin",
  ENDED: "Sonlandı",
};

export const CONDITION_TIME_RATIO = {
  "Sözleşme başlangıcı ve bitişi": "BEGINDENDTIMERATIO",
  "Asla zaman orantılı değil": "NOTTIMERATIO",
  "Yalnızca sözleşme başlangıcı": "BEGINTIMERATIO",
  "Yalnızca sözleşme bitişi": "ENDTIMERATIO",
};
